import { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { routingService } from "../../../Services/routing.service";

export function useRouteCalculation() {
  const { t } = useTranslation();
  const [routeResult, setRouteResult] = useState(null);
  const [calculating, setCalculating] = useState(false);
  const [error, setError] = useState(null);

  const calculate = useCallback(
    async (payload) => {
      setCalculating(true);
      setError(null);

      try {
        const response = await routingService.calculateRoute(payload);

        console.log("ITEMS COUNT:", response?.items?.length);

        console.log(
          "ITEMS:",
          response?.items?.map((i) => ({
            from: i.origin?.address?.formattedAddress,
            to: i.destination?.address?.formattedAddress,
            distance: i.distance?.text,
          }))
        );

        if (response && !response.error) {
          setRouteResult(response);
          return response;
        }

        const message =
          response?.message ||
          response?.friendlyMessage ||
          t("ROUTING.ERROR_CALCULATE_ROUTE");

        setError(message);
        return null;
      } catch (err) {
        console.error("Erro ao calcular rota:", err);
        setError(t("ROUTING.ERROR_CALCULATE_ROUTE"));
        return null;
      } finally {
        setCalculating(false);
      }
    },
    [t]
  );

  const clearResult = useCallback(() => {
    setRouteResult(null);
    setError(null);
  }, []);

  return {
    routeResult,
    calculating,
    error,
    calculate,
    clearResult,
    setRouteResult,
  };
}
